export const supportedLocales = ['de', 'en', 'es', 'tr', 'uk', 'fr', 'it'] as const

export type SupportedCodes = (typeof supportedLocales)[number];
export type LanguageMap = {
  [K in SupportedCodes]: readonly string[];
};

export const languages: LanguageMap = {
  de: ['de', 'de-de', 'de-ch', 'de-at', 'de-lu', 'de-li'],
  en: ['en', 'en-us', 'en-eg', 'en-au', 'en-gb', 'en-ca', 'en-nz', 'en-ie', 'en-za', 'en-jm', 'en-bz', 'en-tt'],
  es: ['es-pe', 'es_pe', 'es', 'es-es', 'es-ar', 'es-bo', 'es-cl', 'es-co', 'es-cr', 'es-gt', 'es-mx'],
  tr: ['tr', 'tr-tr'],
  uk: ['uk', 'uk-uk'],
  fr: ['fr', 'fr-fr'],
  it: ['it', 'it-it'],
} as const

export const privacyStatementsLanguages = ['de', 'en', 'fr', 'it']
export const defaultLocale = 'de'

export const fallbackLocale = import.meta.env.VITE_I18N_LOCALE || import.meta.env.VITE_I18N_FALLBACK_LOCALE || defaultLocale
export const fallbackLocalePrivacy = 'en'

export const getSupportedLanguage = (locales: string[]): { locale: string; origin: SupportedCodes } => {
  const locale =
    locales.find((key) => {
      return Object.keys(languages).find((el) => languages[el as SupportedCodes].includes(key?.toLowerCase()))
    }) || fallbackLocale
  const origin = locale.split(/[\s-|_]+/)[0] as SupportedCodes
  return { locale, origin }
}
